import React, { useContext } from 'react'
import {
    MenuItem,
    Select,
    FormControl,
    FormHelperText
} from '@material-ui/core'
import { CalculatorContext } from '../Context/CalculatorContext'

const CurrencySelect = () => {
    const { currency, setCurrency } = useContext(CalculatorContext)
    return (
        <FormControl>
            <Select
                value={currency}
                onChange={(e) => setCurrency(e.target.value)}
            >
                <MenuItem value="eur">EUR</MenuItem>
                <MenuItem value="usd">USD</MenuItem>
            </Select>
            <FormHelperText>Currency</FormHelperText>
        </FormControl>
    )
}

export default CurrencySelect
